// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"40c2122b","219":"136ed262","235":"377dd058","246":"827b582c","314":"1e4847d6","392":"a686041e","909":"1119859c","977":"eab24fa8"}[chunkId] + ".chunk.js";
};